import { Box } from "@chakra-ui/react";
import React from "react";
import { useDynamicConfig } from "../../../dynamic-config";
import DynamicConfigFlags from "../../../dynamic-config/configs";
import { useMetrics } from "../../../hooks/metrics/useMetrics";
import { VideoImageViewer } from "./VideoImageViewer";
import { VideoOrImageProps } from "./VideoOrImage.types";
import { ModalVideoViewer } from "./ModalVideoViewer";

export const VideoOrImage: React.FC<VideoOrImageProps> = ({
  video,
  image,
  isEditor,
  managerId,
  opportunityId,
  isDisabled,
  ...rest
}) => {
  const [videoOpen, setVideoOpen] = React.useState(false);
  const sendMetric = useMetrics();
  const dynamicConfig = useDynamicConfig();
  const manager = dynamicConfig.get(DynamicConfigFlags.MANAGER);

  if (!video && !image) return <></>;

  const openVideo = () => {
    if (managerId && !isEditor) {
      sendMetric({
        event_type: "click",
        indirect_id: parseInt(managerId),
        indirect_type: "managers",
        object_type: "videos",
        is_marketplace: !(manager && manager.id),
      });
    }

    if (opportunityId) {
      sendMetric({
        event_type: "click",
        indirect_id: parseInt(opportunityId),
        indirect_type: "opportunities",
        object_type: "videos",
        is_marketplace: !(manager && manager.id),
      });
    }

    setVideoOpen(true);
  };

  return (
    <>
      <Box {...rest} position="relative">
        <VideoImageViewer video={video} image={image} />
        <Box
          position="absolute"
          top="0px"
          bottom="0px"
          right="0px"
          left="0px"
          cursor="pointer"
          onClick={() => {
            !isDisabled && openVideo();
          }}
        ></Box>
      </Box>
      {videoOpen && (
        <ModalVideoViewer
          video={video || ""}
          onClose={setVideoOpen.bind(null, false)}
          autoplay
        />
      )}
    </>
  );
};
